/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AccommodationCatalogCityDto } from './accommodation-catalog-city-dto';
import {
    AccommodationCatalogCityDtoFromJSON,
    AccommodationCatalogCityDtoFromJSONTyped,
    AccommodationCatalogCityDtoToJSON,
    AccommodationCatalogCityDtoToJSONTyped,
} from './accommodation-catalog-city-dto';

/**
 * Cities with counts of catalog cards, independent of dates and guests.
 * @export
 * @interface AccommodationCatalogCitiesResponseDto
 */
export interface AccommodationCatalogCitiesResponseDto {
    /**
     * 
     * @type {Array<AccommodationCatalogCityDto>}
     * @memberof AccommodationCatalogCitiesResponseDto
     */
    cities: Array<AccommodationCatalogCityDto>;
}

/**
 * Check if a given object implements the AccommodationCatalogCitiesResponseDto interface.
 */
export function instanceOfAccommodationCatalogCitiesResponseDto(value: object): value is AccommodationCatalogCitiesResponseDto {
    if (!('cities' in value) || value['cities'] === undefined) return false;
    return true;
}

export function AccommodationCatalogCitiesResponseDtoFromJSON(json: any): AccommodationCatalogCitiesResponseDto {
    return AccommodationCatalogCitiesResponseDtoFromJSONTyped(json, false);
}

export function AccommodationCatalogCitiesResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccommodationCatalogCitiesResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'cities': ((json['cities'] as Array<any>).map(AccommodationCatalogCityDtoFromJSON)),
    };
}

  export function AccommodationCatalogCitiesResponseDtoToJSON(json: any): AccommodationCatalogCitiesResponseDto {
      return AccommodationCatalogCitiesResponseDtoToJSONTyped(json, false);
  }

  export function AccommodationCatalogCitiesResponseDtoToJSONTyped(value?: AccommodationCatalogCitiesResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'cities': ((value['cities'] as Array<any>).map(AccommodationCatalogCityDtoToJSON)),
    };
}

